// Format an ISO/UTC timestamp for <input type="datetime-local">, which
// browsers interpret in the user's local timezone. Slicing the raw ISO
// string instead would display UTC clock time and shift the value on
// every edit/save round-trip.
export function toLocalInputValue(value) {
  const d = new Date(value);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
